import {
  BASE_URL,
  CDN_BASE_URL
} from './config.js'
export default {
  content(res) {
    let html;
    if (res) {
      html = res.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:block;"'
      );
    }
    return html;
  },
  imgUrl(e) {
    if (!e) {
      return "";
    } else if (e.substring(0, 4) != "http") {
      return BASE_URL + e;
    } else {
      return e;
    }
  },
  cdnImgUrl(e) {
    if (!e) {
      return "";
    } else if (e.substring(0, 4) != "http") {
      return CDN_BASE_URL + e;
    } else {
      return e;
    }
  },
}



//////////////////
// WEBPACK FOOTER
// ./common/public.js
// module id = null
// module chunks = 